const VALID_SCORE = {
  label: 'Valid',
  labelClass: 'is-success',
};
const INVALID_SCORE = {
  label: 'Invalid',
  labelClass: 'is-error',
};
const WEAK_SCORE = {
  label: 'Weak',
  labelClass: 'is-error',
};
const FAIR_SCORE = {
  label: 'Fair',
  labelClass: 'is-warning',
};
const GOOD_SCORE = {
  label: 'Good',
  labelClass: 'is-success',
};
const STRONG_SCORE = {
  label: 'Strong',
  labelClass: 'is-success',
};

export const PASSWORD_SCORES: Record<string, string>[] = [
  INVALID_SCORE,
  WEAK_SCORE,
  FAIR_SCORE,
  GOOD_SCORE,
  STRONG_SCORE,
];

export function getPasswordScore(score: number | undefined) {
  // Default to a valid score if ZXCVBN is unable to provide a score
  if (score === undefined) {
    return VALID_SCORE;
  }

  return PASSWORD_SCORES[score];
}
